module.exports = "/assets/3fd26068f2f360945e0795e49a4a5a20.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/T7.png
// module id = 2967
// module chunks = 0